// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"var(--primary-color)","primaryFontColor":"var(--primary-font-color)"};